import { TourProvider } from "@reactour/tour";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';


function SECTour({toggleHelp, steps, children}) {

    return (
        <TourProvider 
            steps={steps}
            startAt={0}
            afterOpen={e => {
                disableBodyScroll()
            }} 
            onClickClose={({ setCurrentStep, setIsOpen }) => {
                setIsOpen(false)
                setCurrentStep(0)
            }}

            beforeClose={e => {
                enableBodyScroll()
                toggleHelp()
            }}
            onClickHighlighted={({ setCurrentStep, currentStep, setIsOpen, ...rest }) => {
                rest.stopPropagation()
                if (currentStep === steps.length - 1) {
                    setIsOpen(false)
                }
                setCurrentStep(s => (s === steps.length - 1 ? 0 : s + 1))
            }}
            onClickMask={({ setCurrentStep, currentStep, setIsOpen }) => {
                if (currentStep === steps.length - 1) {
                    setIsOpen(false)
                }
                setCurrentStep(s => (s === steps.length - 1 ? 0 : s + 1))
            }}
            disableInteraction>
            {children}
        </TourProvider>
    )
}

export default SECTour;